module.exports = __webpack_public_path__ + "img/profile-man-15-min.ccbcb296.jpg";